// extracted by mini-css-extract-plugin
module.exports = {"Content":"Legal_Content__1NckT","DateUpdated":"Legal_DateUpdated__2FP6s"};